<script lang="ts">
	import { resolve } from '$app/paths';
	import HessianIcon from '$lib/icons/hessian-icon.svelte';
	import ThemeSwitcher from '$lib/components/theme-switcher.svelte';
	import { cn } from '$utils/cn';
	import { onMount } from 'svelte';

	interface Props {
		class?: string;
	}

	const { class: className = '' }: Props = $props();

	let scrolled = $state(false);

	onMount(() => {
		const onScroll = () => {
			scrolled = window.scrollY > 16;
		};
		onScroll();
		window.addEventListener('scroll', onScroll, { passive: true });
		return () => window.removeEventListener('scroll', onScroll);
	});
</script>

<div
	class={cn(
		'bg-background text-soft fixed z-50 mx-auto flex h-14 w-full items-center border-b px-2 py-2 pl-4 text-sm font-semibold transition-[border-color] duration-300 md:max-w-244 lg:inset-[.5rem_0%_auto] lg:rounded-4xl lg:border',
		scrolled
			? 'dark:border-sidebar-border border-sidebar-border'
			: 'border-transparent lg:border-transparent',
		className
	)}
>
	<a
		href={resolve('/')}
		class="text-primary mr-auto inline-flex flex-row items-center justify-start gap-2"
	>
		<HessianIcon class="fill-primary size-7" />
		<span class="text-xl leading-[1.1] tracking-tighter">Hessian</span>
	</a>

	<ThemeSwitcher showCurrentOnly class="mb-0 size-9 p-0" />
</div>
